module.exports = __webpack_public_path__ + "static/img/web.4c5ffc6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/web.jpg
// module id = aNHX
// module chunks = 1